import { PlayerErrorCategory, PlayerErrorCode } from './types.js';

const CategoryMapping = {
  [PlayerErrorCategory.NETWORK]: [
    PlayerErrorCode.MALFORMED_DATA_URI,
    PlayerErrorCode.BAD_HTTP_STATUS,
    PlayerErrorCode.HTTP_ERROR,
    PlayerErrorCode.TIMEOUT,
    PlayerErrorCode.FILTER_ERROR,
    PlayerErrorCode.NETWORK_OTHER
  ],
  [PlayerErrorCategory.STREAMING]: [
    PlayerErrorCode.SEGMENT_MISSING,
    PlayerErrorCode.INVALID_SEGMENT,
    PlayerErrorCode.MISSING_TEXT_PLUGIN,
    PlayerErrorCode.STREAMING_UNSUPPORTED,
    PlayerErrorCode.STREAMING_ERROR,
    PlayerErrorCode.RESTRICTIONS_CANNOT_BE_MET
  ],
  [PlayerErrorCategory.MANIFEST]: [
    PlayerErrorCode.INVALID_MANIFEST,
    PlayerErrorCode.PERIOD_FLATTENING_FAILED
  ],
  [PlayerErrorCategory.DRM]: [
    PlayerErrorCode.INVALID_KEYSYSTEM,
    PlayerErrorCode.KEYSYSTEM_UNAVAILABLE,
    PlayerErrorCode.DRM_INITIALIZATION_FAILED,
    PlayerErrorCode.INVALID_SERVER_CERTIFICATE,
    PlayerErrorCode.FAILED_TO_GENERATE_LICENSE_REQUEST,
    PlayerErrorCode.LICENSE_REQUEST_FAILED,
    PlayerErrorCode.LICENSE_RESPONSE_REJECTED,
    PlayerErrorCode.DRM_INVALID_CONFIG,
    PlayerErrorCode.LICENSE_EXPIRED,
    PlayerErrorCode.SERVER_CERTIFICATE_REQUEST_FAILED,
    PlayerErrorCode.DRM_RESTRICTED_OUTPUT,
    PlayerErrorCode.OFFLINE_SESSION_REMOVED,
    PlayerErrorCode.DRM_OTHER
  ],
  [PlayerErrorCategory.OTHER]: [
    PlayerErrorCode.LOAD_INTERRUPTED,
    PlayerErrorCode.OPERATION_ABORTED,
    PlayerErrorCode.BAD_PLAYER_INITIALIZATION,
    PlayerErrorCode.OBJECT_DESTROYED,
    PlayerErrorCode.OTHER
  ]
};

export { CategoryMapping };
//# sourceMappingURL=mapping.js.map
